import { useState } from "react";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  AreaChart,
  Area,
} from "recharts";

const data = [
  {
    GST: 0,
    TDS: 4347,
    Year: 2023,
    Month: 1,
    NetPay: 82594.4,
    Revenue: 86941.4,
    TranDate: "2023-01-31",
  },
  {
    GST: 0,
    TDS: 3987,
    Year: 2023,
    Month: 2,
    NetPay: 75751.85,
    Revenue: 79738.85,
    TranDate: "2023-02-28",
  },
  {
    GST: 0,
    TDS: 3694,
    Year: 2023,
    Month: 3,
    NetPay: 70192.81,
    Revenue: null,
    TranDate: "2023-03-31",
  },
  {
    GST: 0,
    TDS: 4373,
    Year: 2023,
    Month: 4,
    NetPay: 83092.61,
    Revenue: 87465.61,
    TranDate: "2023-04-29",
  },
  {
    GST: 0,
    TDS: 5711,
    Year: 2023,
    Month: 5,
    NetPay: 108512.21,
    Revenue: 114223.21,
    TranDate: "2023-05-31",
  },
  {
    GST: 0,
    TDS: 6185,
    Year: 2023,
    Month: 6,
    NetPay: 117511.25,
    Revenue: 123696.25,
    TranDate: "2023-06-30",
  },
  {
    GST: 0,
    TDS: 4607,
    Year: 2023,
    Month: 7,
    NetPay: 87526.04,
    Revenue: 92133.04,
    TranDate: "2023-07-31",
  },
  {
    GST: 0,
    TDS: 5154,
    Year: 2023,
    Month: 8,
    NetPay: 97923.56,
    Revenue: 103077.56,
    TranDate: "2023-08-31",
  },
  {
    GST: 0,
    TDS: 9797,
    Year: 2023,
    Month: 9,
    NetPay: 186136.64,
    Revenue: 195933.64,
    TranDate: "2023-09-30",
  },
  {
    GST: 0,
    TDS: 9824,
    Year: 2023,
    Month: 10,
    NetPay: 186646.89,
    Revenue: 196470.89,
    TranDate: "2023-10-31",
  },
  {
    GST: 0,
    TDS: 9824,
    Year: 2023,
    Month: 11,
    NetPay: 186646.89,
    Revenue: null,
    TranDate: "2023-10-31",
  },
  {
    GST: 0,
    TDS: 9824,
    Year: 2023,
    Month: 12,
    NetPay: 186646.89,
    Revenue: null,
    TranDate: "2023-10-31",
  },
];
interface Props {
  revenueGraphData: any;
  loading: boolean;
}

const PaymentGraph = ({ revenueGraphData, loading }: Props) => {
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;

  const generateDataFor30Days = () => {
    const data:any = [];

    for (let i = 1; i <= 30; i++) {
      const day = i < 10 ? `0${i}` : `${i}`;
      const randomPV = Math.floor(Math.random() * 10000) + 2000;
      const randomAmt = Math.floor(Math.random() * 3000) + 1000;

      data.push({
        name: day,
        pv: randomPV,
        amt: randomAmt,
      });
    }

    return data;
  };

  // console.log("revenueGraphData",revenueGraphData)

  return (
    <>
      <ResponsiveContainer width="100%" height={"100%"}>
        <AreaChart
          width={730}
          height={250}
          data={revenueGraphData}
          margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
        >
          {revenueGraphData.length > 0 && !loading ? (
            <>
              <XAxis
                dataKey="month"
                axisLine={true}
                tickLine={false}
                tick={{ fontSize: 12, fill: "#A3AED0", fontWeight: "500" }}
              />
              <YAxis
                axisLine={true}
                tickLine={false}
                tick={{ fontSize: 12, fill: "#A3AED0", fontWeight: "500" }}
              />
              <CartesianGrid strokeOpacity={0.3} />
              <Tooltip
                // itemStyle={{
                //   color: "rgba(0, 103, 121, 1)",
                //   fontSize: "14px",
                //   fontWeight: 600,
                // }}
                content={<CustomTooltip />}
                // position={{ x: 300, y: -100 }}
                // cursor={{ stroke: 'red', strokeWidth: 2 }}
              />

              <Area
                type="linear"
                dataKey="Revenue"
                stroke="rgba(40, 98, 130, 0.5)"
                fillOpacity={1}
                fill="rgba(40, 98, 130, 0.5)"
                dot={{
                  stroke: "rgba(0, 103, 121, 1)",
                  strokeWidth: 1,
                  fill: "rgba(0, 103, 121, 1)",
                }}
              />
            </>
          ) : (
            <>
              <text
                x="50%"
                y="50%"
                textAnchor="middle"
                dominantBaseline="middle"
                fontSize="16"
                fill="#888"
              >
                {loading ? "Loading..." : "No Data Found"}
              </text>
            </>
          )}
        </AreaChart>
      </ResponsiveContainer>
    </>
  );
};

export default PaymentGraph;

const CustomTooltip = ({ active, payload, label }: any) => {
  // console.log("active", active, "label", label, "payload", payload);
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          background: "rgba(213, 233, 236, 1)",
          border: "1px solid rgba(0, 103, 121, 1)",
          borderRadius: "10px",
          padding: "5px 10px",
        }}
      >
        <p style={{ fontSize: "12px", fontWeight: 400 }}>{`Month ${label}`}</p>
        <p
          style={{ fontSize: "14px", fontWeight: 500 }}
        >{`₹${payload[0]?.payload?.Revenue}`}</p>
      </div>
    );
  }

  return null;
};
